import { ReactElement } from 'react';

import { FormContextValues } from '@dreryk/react-common';
import { FormLabel, StyledFlex, TextView } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { WithNameForReceipt } from './nameForReceipt.types';

type MedicalServiceNameForReceiptTextViewProps = Pick<FormContextValues<WithNameForReceipt>, 'watch'> & {
   readonly children: ReactElement | ReactElement[];
   readonly disabled?: boolean;
};

export const MedicalServiceNameForReceiptTextView = (props: MedicalServiceNameForReceiptTextViewProps): JSX.Element => {
   const { nameForReceiptType } = props.watch(['nameForReceiptType']);
   const required = nameForReceiptType === 'OTHER';

   return (
      <TextView
         testId={'nameForReceipt'}
         label={
            <FormLabel
               testId={'nameForReceipt'}
               label={medicalServiceTranslationKeys.shared.nameForReceipt.textView.label}
               disabled={props.disabled}
               required={required}
            />
         }
      >
         <StyledFlex direction={'column'} gap={'8px'}>
            {props.children}
         </StyledFlex>
      </TextView>
   );
};
